<template>
	<div>
		<div style="display: flex; width: 100%">
			<div style="width: 65%; margin-top: 5px">
				<h3>Top Non Compliant Questions</h3>
			</div>
			<div v-if="viewType != '1'" style="width: 20%">
				<input
					type="text"
					v-model="search"
					placeholder="Search Question"
					class="searchicon"
				/>
			</div>
			<div style="margin-left: auto">
				<el-button
					icon="el-icon-download"
					style="margin-top: 0px; margin-left: 20px"
					class="button-class-new"
					@click="exportCSVTopNonComplaint()"
				>
					Download Reports
				</el-button>
			</div>
		</div>
		<div
			class="top-non-complaint-table"
			style="margin-top: 10px"
			:style="viewType == '1' ? 'height:275px; overflow-y:auto' : ''"
		>
			<el-table
				style="
					text-transform: capitalize;
					word-break: break-word;
					width: 100%;
					margin-bottom: 10px;
				"
				:data="
					viewType == '1'
						? computedTopNonComplaintsData
						: computedTopNonComplaintsData.filter(
								(el, index) => index >= startNumber - 1 && index < endNumber
						  )
				"
				class="ns-top-non-comp-tbl"
				min-height="200"
				max-height="500"
			>
				<el-table-column
					:width="viewType != '1' ? '' : ''"
					v-if="viewType == '1'"
					prop="name"
					label="Questions"
					style="word-break: break-word"
				>
					<!-- <template slot-scope="scope">
						<div
							@click="showInDetailsQue(scope.row, '1')"
							style="
								text-transform: capitalize;
								word-break: break-word;
								font-size: 12px;
								cursor: pointer;
								color: #1b93eb;
							"
						>
							{{ scope.row.name != 0 ? scope.row.name.length>100?scope.row.name.slice(0, 100) + "...": scope.row.name: "-" }}
						</div>
					</template> -->
					<template slot-scope="scope">
						<el-tooltip
							v-if="scope.row.name != 0 && scope.row.name.length > 100"
							:content="scope.row.name"
							placement="bottom"
							class="custom-tooltip"
						>
							<div
								@click="showInDetailsQue(scope.row, '1')"
								style="
									text-transform: capitalize;
									word-break: break-word;
									font-size: 12px;
									cursor: pointer;
									color: #1b93eb;
								"
							>
								{{ scope.row.name.slice(0, 100) + "..." }}
							</div>
						</el-tooltip>
						<div
							v-else
							@click="showInDetailsQue(scope.row, '1')"
							style="
								text-transform: capitalize;
								word-break: break-word;
								font-size: 12px;
								cursor: pointer;
								color: #1b93eb;
							"
						>
							{{ scope.row.name != 0 ? scope.row.name : "-" }}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					v-if="viewType != '1'"
					prop="name"
					label="Questions"
					style="word-break: break-word"
				>
					<template slot="header" slot-scope="scope">
						Questions
						<el-popover placement="right" trigger="click">
							<el-input
								v-model="searchedQuestion"
								size="mini"
								:placeholder="`Search Question`"
							></el-input>
							<div style="max-height: 200px; overflow: auto; margin-top: 10px">
								<el-checkbox-group v-model="selectedQuestion">
									<el-checkbox
										v-for="(formItem, index) in uniqueQuestions.filter(
											(el) =>
												!searchedQuestion ||
												el
													.toLowerCase()
													.includes(searchedQuestion.toLowerCase())
										)"
										:key="index"
										class="mb-2 checkbox-box"
										:label="formItem"
										style="display: block"
									></el-checkbox>
								</el-checkbox-group>
							</div>
							<div class="flex justify-between mt-4">
								<span
									class="text-xs cursor-pointer primary-theme-color"
									@click="selectedQuestion = [...uniqueQuestions]"
									>Select all</span
								>
								<span
									class="text-xs cursor-pointer"
									@click="selectedQuestion = []"
									>Reset</span
								>
							</div>
							<span slot="reference">
								<img
									v-if="selectedQuestion.length"
									src="../../../../assets/images/filter.png"
									width="9"
									class="cursor-pointer"
								/>
								<img
									v-else
									src="../../../../assets/images/filterBlack.png"
									width="9"
									class="cursor-pointer"
								/>
							</span>
						</el-popover>
					</template>
					<template slot-scope="scope">
						<div
							@click="showInDetailsQue(scope.row, '2')"
							style="
								text-transform: capitalize;
								word-break: break-word;
								font-size: 12px;
								cursor: pointer;
								color: #1b93eb;
							"
						>
							{{ scope.row.name != 0 ? scope.row.name : "-" }}
						</div>
					</template>
				</el-table-column>
				<el-table-column v-if="viewType != '1'" width="180px">
					<template slot-scope="scope">
						<div :style="scope.row.is_critical ? 'color:red' : ''">
							{{ scope.row.is_critical ? "CRITICAL" : "" }}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					v-if="viewType == '1'"
					label="Failed Response"
					width="150px"
				>
					<template slot-scope="scope">
						<div style="text-transform: none">
							{{ scope.row.failed_count }} of {{ scope.row.total }}
						</div>
					</template>
				</el-table-column>
				<el-table-column v-if="viewType != '1'" label="Total" width="180px">
					<template slot-scope="scope">
						{{ scope.row.total }}
					</template>
				</el-table-column>

				<el-table-column
					v-if="viewType != '1'"
					width="230px"
					label="Failed Response"
					show-overflow-tooltip
				>
					<template slot-scope="scope">
						{{ scope.row.failed_count }}
					</template>
				</el-table-column>
				<el-table-column
					v-if="viewType == '1'"
					width="100px"
					label="Fail %"
					show-overflow-tooltip
				>
					<template slot-scope="scope">
						{{ ((scope.row.failed_count / scope.row.total) * 100).toFixed(2) }}%
					</template>
				</el-table-column>
				<el-table-column
					v-if="viewType != '1'"
					width="170px"
					label="Fail %"
					show-overflow-tooltip
				>
					<template slot="header" slot-scope="scope">
						Fail %
						<span slot="reference" class="cursor-pointer">
							<i
								v-if="failPerOrder == 'desc'"
								class="el-icon-caret-top"
								style="font-size: 12px"
								v-on:click="failPerOrder = 'asc'"
							></i>
							<i
								v-if="failPerOrder == '' || failPerOrder == 'asc'"
								class="el-icon-caret-bottom"
								style="font-size: 12px"
								v-on:click="failPerOrder = 'desc'"
							></i>
						</span>
					</template>
					<template slot-scope="scope">
						{{ ((scope.row.failed_count / scope.row.total) * 100).toFixed(2) }}%
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-row v-if="viewType != '1'" :gutter="10" class="mt-3">
			<el-col :span="8" class="text-left">
				<div>
					<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
					{{ computedTopNonComplaintsData.length }} results
				</div>
			</el-col>
			<el-col :span="8" class="text-center">
				<el-select
					v-model="perPage"
					name="per_page"
					placeholder="select per page"
					style="width: 90px !important"
					size="mini"
				>
					<el-option v-if="viewType == '2'" label="5" :value="5"></el-option>
					<el-option label="10" :value="10"></el-option>
					<el-option label="25" :value="25"></el-option>
					<el-option label="50" :value="50"></el-option>
					<el-option label="100" :value="100"></el-option>
				</el-select>
				&nbsp;<b>per page</b>
			</el-col>
			<el-col :span="8" class="text-right">
				<el-pagination
					background
					layout="prev, pager, next"
					:total="computedTopNonComplaintsData.length"
					:page-size="perPage"
					:current-page.sync="currentPage"
				></el-pagination>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import exportFromJSON from "export-from-json";
import { mapState, mapActions } from "vuex";
var moment = require("moment");

export default {
	props: {
		topNonComplaintsData: Array,
		viewType: String,
		projectsTasks: String,
		projectsTasksItems: Array,
		dates: Array,
	},
	data: () => ({
		currentPage: 1,
		perPage: 10,
		search: "",
		moment: moment,
		searchedQuestion: "",
		selectedQuestion: [],
		failPerOrder: "",
	}),
	computed: {
		uniqueQuestions() {
			let arr = [
				...new Set([...this.topNonComplaintsData].map((el) => el.name)),
			];
			return arr;
		},
		computedTopNonComplaintsData() {
			let data = [...this.topNonComplaintsData];
			if (this.viewType == "1") {
				data = data.splice(0, 5);
			}
			if (this.search.length) {
				data = data.filter((el) =>
					el.name.toLowerCase().includes(this.search.toLowerCase())
				);
			}
			if (this.selectedQuestion) {
				data = data.filter(
					(el) =>
						!this.selectedQuestion.length ||
						this.selectedQuestion.includes(el.name)
				);
			}
			if (this.failPerOrder) {
				if (this.failPerOrder.toString().toLowerCase() == "asc") {
					data = data.sort((a, b) => {
						const failurePercentageA = (
							(a["failed_count"] / a["total"]) *
							100
						).toFixed(2);
						const failurePercentageB = (
							(b["failed_count"] / b["total"]) *
							100
						).toFixed(2);
						return failurePercentageA - failurePercentageB;
					});
				}
				if (this.failPerOrder.toString().toLowerCase() == "desc") {
					data = data.sort((a, b) => {
						const failurePercentageA = (
							(a["failed_count"] / a["total"]) *
							100
						).toFixed(2);
						const failurePercentageB = (
							(b["failed_count"] / b["total"]) *
							100
						).toFixed(2);
						return failurePercentageB - failurePercentageA;
					});
				}
			}
			return data;
		},
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumber() {
			let end = Math.min(
				this.startNumber + this.perPage - 1,
				this.computedTopNonComplaintsData.length
			);
			return end;
		},
	},
	methods: {
		...mapActions("CommonStore", [
			"addDownloadingReportCountAction",
			"removeDownloadingReportCountAction",
		]),
		exportCSVTopNonComplaint() {
			this.addDownloadingReportCountAction("Report");
			let data = null;
			data = [...this.topNonComplaintsData].map((el) => {
				let item = {
					Questions: el.name,
					Critical: el.is_critical ? "Yes" : "No",
					Total: el.total,
					"Failed Response": el.failed_count,
					"Fail %": ((el.failed_count / el.total) * 100).toFixed(2) + "%",
				};
				return item;
			});
			const fileName = `Top Non Compliant Questions ${
				this.projectsTasksItems.length != 0
					? this.projectsTasksItems.filter((el) =>
							el.id.includes(this.projectsTasks)
					  )[0].name
					: "-"
			} ( ${this.moment(this.dates[0]).format("Do MMM YYYY")} - ${this.moment(
				this.dates[1]
			).format("Do MMM YYYY")} )`;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data, fileName, exportType });
			this.removeDownloadingReportCountAction();
		},
		showInDetailsQue(row, type) {
			this.$emit("show_row_data", row);
			this.$emit("checkTypeToggle", type);
		},
	},
};
</script>

<style>
.checkbox-box {
	max-width: 500px !important;
	text-overflow: ellipsis !important;
}
.custom-tooltip {
	width: 500px !important; /* Set your desired width */
	white-space: normal; /* Allow line breaks if the content is long */
	word-break: break-all;
}
</style>
